import { useMutation } from '@tanstack/react-query'
import { authApi } from 'shared/api/auth'

interface DisableTwoFactorByCode {
  code: string
}
interface DisableTwoFactorByOtp {
  otp: string
}

export type DisableTwoFactorRequest =
  | DisableTwoFactorByCode
  | DisableTwoFactorByOtp

interface DisableTwoFactorResponse {}

const disableTwoFactor = async (data: DisableTwoFactorRequest) => {
  const response = await authApi.post<DisableTwoFactorResponse>(
    'otp' in data ? '/2fa/deactivate-by-otp' : '/2fa/deactivate-by-code',
    data
  )
  return response.data
}

export const useDisableTwoFactor = ({
  onSuccess,
  onError
}: {
  onSuccess?: () => void
  onError?: () => void
}) => {
  const mutation = useMutation({
    mutationFn: (data: DisableTwoFactorRequest) => disableTwoFactor(data),
    onSuccess: () => {
      onSuccess?.()
    },
    onError: () => {
      onError?.()
    }
  })

  return { mutation }
}
